import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

// Types
import { UserSuggestion } from 'Shared/types/UserSuggestion.type';
import { User } from 'Shared/constants/types';

// Selectors
import * as UsersSelectors from 'Shared/selectors/Users.selectors';

// Actions
import { updateUserSuggestion } from 'Shared/actions/UserSuggestions.actions';

export const useUserSuggestion = ({ userSuggestion }: { userSuggestion: UserSuggestion }) => {
  const dispatch = useDispatch();

  const otherUser =
    (useSelector(state =>
      UsersSelectors.getUserByUserSlug(state, { userSlug: userSuggestion.otherUserPublicId })
    )?.toJS() as User) || null;

  const handleDismissSuggestion = () => {
    // only track the first click
    const data = {
      dismissed_at: new Date().toISOString(),
    };

    dispatch(updateUserSuggestion({ slug: userSuggestion.slug, data }));
  };

  const handleUpdateClickedAt = () => {
    // only track the first click
    if (userSuggestion.clickedAt) return null;
    const data = {
      clicked_at: new Date().toISOString(),
    };

    dispatch(updateUserSuggestion({ slug: userSuggestion.slug, data }));
  };

  const handleUpdateLastSeenAt = () => {
    const data = {
      last_seen_at: new Date().toISOString(),
    };

    dispatch(updateUserSuggestion({ slug: userSuggestion.slug, data }));
  };

  const handleUpdateCompletedAt = () => {
    const data = {
      completed_at: new Date().toISOString(),
    };

    dispatch(updateUserSuggestion({ slug: userSuggestion.slug, data }));
  };

  return { otherUser, handleDismissSuggestion, handleUpdateClickedAt, handleUpdateLastSeenAt, handleUpdateCompletedAt };
};
